// styles
import styled from "styled-components";
import { mobile } from "../../../styles/responsive";
// types
import { PassengerAuthorization } from "../../../types/common.types";
import { FaCheck } from "react-icons/fa6";
import { IoCloseOutline } from "react-icons/io5";
import { format} from "date-fns";
import AdminService from "../../../services/admin.service"
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useAdmin } from "../../../context/admin";
import { useGlobal } from "../../../context/global";

export default function List({data}: {data: PassengerAuthorization[]}) {
    const { setIsLoading } = useGlobal()
    const { setPassengerPlanId } = useAdmin()
    async function handleAuthorization (id: string, action: 'approve' | 'reject') {
        setIsLoading(true)
        try {
            if (action === 'approve') {
                await AdminService.approvePassengerAuthorization(id)
            } else {
                await AdminService.rejectPassengerAuthorization(id)
            }
            window.location.reload()
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false) 
        }
    }
    return (
        <Main>
            {
                data.map((item) => {
                    return (
                        <div key={item.id} className="authorization">
                            <div className="header">
                                <span className="name">Change passenger info request: {item.status} | {format(new Date(item.created_at), 'dd/MM/yyyy HH:mm')}</span>
                                {
                                    item.status === 'pending' &&
                                    <div className="actions">
                                        <button className="approve"
                                        onClick={() => handleAuthorization(item.id, 'approve')}
                                        ><FaCheck/></button>
                                        <button className="reject"
                                        onClick={() => handleAuthorization(item.id, 'reject')}
                                        ><IoCloseOutline/></button>
                                    </div>
                                }
                            </div>
                            <TableWrapper>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Rut/Passport</th>
                                            <th>Age</th>
                                            <th>Hotel</th>
                                            <th>Remark</th>
                                            <th>Nationality</th>
                                            {
                                                item.status === 'pending' &&
                                                <th style={{width: '40px'}}></th>
                                            }
                                            { 
                                                item.status !== 'pending' && 
                                                <>
                                                <th>Authorized At</th>
                                                <th>Authorized By</th>
                                                </>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{item.passenger.name}</td>
                                            <td>{item.passenger.email}</td>
                                            <td>{item.passenger.phone}</td>
                                            <td>{item.passenger.rut_passport}</td>
                                            <td>{item.passenger.age}</td>
                                            <td>{item.passenger.hotel}</td>
                                            <td>{item.passenger.remark}</td>
                                            <td>{item.passenger.nationality}</td>
                                            {
                                                item.status === 'pending' &&
                                                <td><button className="info" onClick={() => setPassengerPlanId(item.passenger_id)}><AiOutlineInfoCircle/></button></td>
                                                
                                            }
                                            {
                                                item.status !== 'pending' &&
                                                <>
                                                    <td>{format(new Date(item.authorized_at), 'dd/MM/yyyy HH:mm:ss')}</td>
                                                    <td>{item.admin?.name || 'Agency'}</td>
                                                </>
                                            }
                                        </tr>
                                    </tbody>
                                </Table>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>New Name</th>
                                            <th>New Email</th>
                                            <th>New Phone</th>
                                            <th>New Rut/Passport</th>
                                            <th>New Age</th>
                                            <th>New Hotel</th>
                                            <th>New Remark</th>
                                            <th>Nationality</th>
                                            {
                                                item.status === 'pending' &&
                                                <th style={{width: '40px'}}></th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{item.name}</td>
                                            <td>{item.email}</td>
                                            <td>{item.phone}</td>
                                            <td>{item.rut_passport}</td>
                                            <td>{item.age}</td>
                                            <td>{item.hotel}</td>
                                            <td>{item.remark}</td>
                                            <td>{item.nationality}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </TableWrapper>
                        </div>
                    )
                })
            }
        </Main>
    )
}

const Main = styled.div`
display: flex;
flex-direction: column;
gap: 15px;
width: 90%;
margin: auto;
margin-top: 15px;
${mobile({
    width: '100%'
})}
overflow: unset;
.authorization {
    background-color: ${props => props.theme.whiteBackground};
    border-radius: 10px;
    box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
    cursor: pointer;
    transition: all .3s ease;
    &:hover {
        box-shadow: 0 5px 10px ${props => props.theme.blackTransparent};
        transform: translateY(-3px);
    }
    .header {
        .name {
            flex: 1;
            text-align: center;
        }
        .actions {
            height: 100%;
            display: flex;
            gap: 5px;
            padding: 5px;
            button {
                height: 100%;
                width: 50px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                color: ${props => props.theme.white};
            }
            button.reject {
                background-color: ${props => props.theme.lightRed};
            }
            button.approve {
                background-color: ${props => props.theme.lightGreen};
            }
        }
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px 10px 0 0;
        position: relative;
        height: 40px;
        background-color: ${props => props.theme.black};
        color: ${props => props.theme.white};
    }
}
`

const TableWrapper = styled.div`
width: 100%;
height: 100%;
overflow: hidden;
overflow-x: unset;
`

const Table = styled.table`
border-collapse: collapse;
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
min-width: 500px;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    > button {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
            }
    }
    >button.selected-all {
        background-color: ${props => props.theme.yellowDark};
    }
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .flag {
        width: 30px;
    }
    button.select {
        width: 20px;
        height: 20px;
        color: #000;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    button.selected {
        background-color: ${props => props.theme.yellowDark};
    }
    button.info {
        border: none;
        background-color: none;
        font-size: 16px;
        cursor: pointer;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`